import { FaStar } from "react-icons/fa6";
import { FaRegStarHalfStroke } from "react-icons/fa6";
import { FaCartArrowDown, FaRegHeart, FaShare } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { useContext } from "react";
import { CartContext } from "../Context/CartContext";
import { FaCheck } from "react-icons/fa";
import toast from "react-hot-toast";

function Product({ item }) {
  let navigate = useNavigate();

  let { cartitem, addtoCart, addtofavorites, favorites, removefromfavorite } =
    useContext(CartContext);
  console.log(cartitem);

  let isincart = cartitem.some((i) => i.id === item.id);

  let handelAddtocart = () => {
    addtoCart(item);

    toast.success(
      <div className="toast_werpper">
        <img src={item.images[0]} alt="" className="toast-img"></img>

        <div className="toast_content">
          <strong>{item.title}</strong>
          Added To Cart
          <div>
            <button onClick={() => navigate("/Cart")} className="btn">
              View Cart
            </button>
          </div>
        </div>
      </div>,
      { duration: 3500 }
    );
  };

  // favorites
  let isInfav = favorites.some((i) => i.id === item.id);
  let handltofav = () => {
    console.log(isInfav);
    if (isInfav) {
      removefromfavorite(item.id);
      toast.error(`${item.title} remove from Favorites`);
    } else {
      addtofavorites(item);
      toast.success(`${item.title} Added To Favorites`);
    }
  };

  return (
    <div className={`Product ${isincart ? "in-cart" : ""}`}>
      <Link to={`/products/${item.id}`}>
        <span className="stute-Cart">
          <FaCheck /> in Cart
        </span>
        <div className="img_product">
          <img src={item.images[0]} alt=""></img>
        </div>
        <p className="name_product">{item.title}</p>
        <div className="stars">
          <FaStar />
          <FaStar />
          <FaStar />
          <FaStar />
          <FaRegStarHalfStroke />
        </div>
        <p className="price">
          {" "}
          <span>$ {item.price}</span>
        </p>
      </Link>

      <div className="icons">
        <span onClick={handelAddtocart} className="btntocart">
          <FaCartArrowDown />
        </span>
        <span className={`${isInfav ? "In-fav" : ""}`} onClick={handltofav}>
          <FaRegHeart />
        </span>
        <span>
          <FaShare />
        </span>
      </div>
    </div>
  );
}

export default Product;
